import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import PageTemplate from '../../components/template/PageTemplate';
import SearchWordSaveContainer from '../../containers/searchWord/SearchWordSaveContainer';
import { searchWordActions } from '../../store/modules/searchWord';
import { SEARCH_WORD_SAVE_MODEL } from '../../store/modules/searchWord/models';
import { INVALID_DUPLICATE_SEARCH_WORD_MESSAGE } from '../../constants/service/invalidMsg/SearchWordInvalidMsg';
import { SEARCH_WORD_PAGE_NAME } from '../../constants/service/app/searchWordConstants';

class SearchWordCreate extends Component {
  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['searchWordSave'],
      value: SEARCH_WORD_SAVE_MODEL,
    });
  }

  /**
   *  등록하기
   */
  onSubmit = (data) => {
    const { createSearchWord } = this.props;
    const { word, isDuplicateWord, relatedKeywordList } = data;

    /**
     *  중복된 키워드인 경우 등록 안됨
     */
    if (isDuplicateWord) {
      message.error(INVALID_DUPLICATE_SEARCH_WORD_MESSAGE);
      return;
    }

    createSearchWord({
      word,
      relatedKeywordNameList: relatedKeywordList.nameList,
    });
  };

  render() {
    return (
      <PageTemplate pageName={SEARCH_WORD_PAGE_NAME.SEARCH_WORD_CREATE}>
        <SearchWordSaveContainer onSubmit={this.onSubmit} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: searchWordActions.setData,
  createSearchWord: searchWordActions.createSearchWord,
};

export default connect(null, mapDispatchToProps)(SearchWordCreate);
